export const stepNames = [
    'Validate Data',
    'Generate D',
    'Cross File',
    'Generate EF',
    'Review & Publish'
];

export const classes = {
    step: 'usa-da-progress-bar-step-step',
    current: 'usa-da-progress-bar-step-current',
    done: 'usa-da-progress-bar-step-done'
};

